export default "__VITE_ASSET__1295321d__"